export const fetchConfig = {
  endpoint: `https://graphql.contentful.com/content/v1/spaces/i3820ws8fk9m`,
  params: {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${process.env.CONTENTFUL_ACCESS_TOKEN_i3820ws8fk9m}`,
    },
  },
};
